import { PureComponent, ReactNode } from "react";
import { DispatchProp } from "react-redux";
import { connectRedux } from '../../helpers/connectRedux'

import { IFeedback, IFeedbackOption } from "../../models";
import { IExpeditionStatus } from "../../models/expedition-status";
import { Modal } from "../../components";
import React from "react";
import { IStoreState } from "../../store/states";
import { FeedbackService, LiteralsService } from "../../services";
import StyledDiv from './styles';
import { images } from "../../images";
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction> {
  reservationId: number | null
  feedback: IFeedback | null
  expeditionStatus: IExpeditionStatus
  isShowNotificationModal: boolean
}

interface IState {
  feedbackOptions: IFeedbackOption[]
  badFeedbackSelected: boolean
  isVisible?: boolean
}

class FeedbackModal extends PureComponent<IProps, IState> {

  private get modalTitle(): string {
    const { badFeedbackSelected } = this.state
    return LiteralsService.get(badFeedbackSelected ? 'whatProblem' : 'valueExperience', true)
  }

  private get feedbackContent(): ReactNode {
    const { badFeedbackSelected } = this.state
    return (
      badFeedbackSelected ? 
      <div className="options-container">
        { this.feedbackOptionsList }
      </div> :
      <div>
        <div className="buttons-container">
          <div className="feedback-button positive" onClick={() => this.handleGoodFeedbackSelect()}>
            <img src={images.positive} alt="positive-feedback" />
          </div>
          <div className="feedback-button negative" onClick={() => this.handleBadRequestSelect()}>
            <img src={images.negative} alt="negative-feedback" />
          </div>
        </div>
      </div>
    )
  }

  private get feedbackOptionsList(): ReactNode {
    const { feedbackOptions } = this.state
    if (!feedbackOptions) return null
    return feedbackOptions.map((option) => {
      return (
        <div key={`feedback-option-${option.id}`} className="option" onClick={() => this.handleBadFeedbackSelect(option.id)}>
          <span>{ option.description }</span>
        </div>
      )
    })
  }

  constructor(props: IProps) {
    super(props)
    this.state = {
      badFeedbackSelected: false,
      feedbackOptions: [],
      isVisible: undefined
    }
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState): void {
    const { feedback, expeditionStatus, isShowNotificationModal } = this.props
    const { badFeedbackSelected, feedbackOptions } = this.state

    const showModal = !(feedback && feedback.reservation) && (expeditionStatus && expeditionStatus === IExpeditionStatus.Closed)

    if (prevState.isVisible === undefined && expeditionStatus && !isShowNotificationModal) {
      this.setState({
        isVisible: showModal ? showModal : false
      })
    }

    const expeditionStatusChangedToClose = (prevProps.expeditionStatus && prevProps.expeditionStatus !== IExpeditionStatus.Closed) && (expeditionStatus && expeditionStatus === IExpeditionStatus.Closed)

    if (!expeditionStatus || expeditionStatusChangedToClose) this.setState({ isVisible: undefined })
    if (badFeedbackSelected && feedbackOptions.length === 0) this.fetchFeedbackOptionsList()
  }

  public render() {
    const { isVisible } = this.state
    
    if (!isVisible) return null
    return (
      <Modal className="small">
        <StyledDiv>
          <header>
            <h3>{ this.modalTitle }</h3>
          </header>
          <section>
            { this.feedbackContent }
          </section>
          <footer>
            <div className="skip" onClick={this.handleCloseFeedback}>
              { LiteralsService.get('skip', true) }
            </div>
          </footer>
        </StyledDiv>
      </Modal>
    )
  }

  fetchFeedbackOptionsList = async () => {
    const feedbackOptions = await FeedbackService.getFeedbackOptions()
    this.setState({ feedbackOptions })
  }

  async handleGoodFeedbackSelect(): Promise<void> {
    const { reservationId } = this.props
    try {
      const feedback: IFeedback = {
        option: undefined,
        positive: true,
        reservation: { id: reservationId ? reservationId.toString() : '' }
      }
      await FeedbackService.sendFeedback(feedback)
    } catch (error) {
      // tslint:disable-next-line: no-console
      console.error(error)
    }
    this.handleCloseFeedback()
  }

  async handleBadFeedbackSelect(id: number): Promise<void> {
    const { reservationId } = this.props
    try {
      const feedback: IFeedback = {
        option: { id },
        positive: false,
        reservation: { id: reservationId ? reservationId.toString() : '' }
      }
      await FeedbackService.sendFeedback(feedback)
    } catch (error) {
      // tslint:disable-next-line: no-console
      console.error(error)
    }
    this.handleCloseFeedback()
  }

  handleBadRequestSelect(): void {
    this.setState({ badFeedbackSelected: true })
  }

  handleCloseFeedback = () => {
    this.setState({ badFeedbackSelected: false, isVisible: false })
  }
}

const mapStateToProps = ({ reservations }: IStoreState) => ({
  reservationId: reservations.pickedReservation && reservations.pickedReservation.id,
  feedback: reservations.pickedReservation && reservations.pickedReservation.feedback,
  expeditionStatus: reservations.pickedReservation ? reservations.pickedReservation.expeditionStatus : '',
  isShowNotificationModal: reservations.isShowNotificationModal
})

export default connectRedux(mapStateToProps, FeedbackModal as any)